/** Public company contact details shown on the website. */
export const MERCHANT_LEGAL = {
  brandName: "InfinityWhale",
  supportEmail: "support@infinitywhale.com",
  supportPhone: "+91 81234 65557",
  supportPhoneTel: "+918123465557",
  gstin: "29AZWPG7040B1Z8",
  addressLines: [
    "Building number 63E, Kothnoor dinne main road",
    "Near Ganesh temple JP nagar 8th phase, Kothnoor village",
    "Bengaluru, Bengaluru Urban, Karnataka, 560076",
    "India",
  ],
};

export const merchantAddressMultiline = MERCHANT_LEGAL.addressLines.join("\n");
